import { useQuery } from "@tanstack/react-query";
import { UserSuggestionsOrderingType } from "../types/api/userSuggestions";
import { fetchUserSuggestions } from "../services/userSuggestions";
import { FeedbackStatus } from "../types/api/feedback";

export const useUserSuggestionsQuery = (
  search: string = "",
  page: number,
  limit: number,
  ordering?: UserSuggestionsOrderingType,
  status?: FeedbackStatus
) => {
  return useQuery({
    refetchOnWindowFocus: false,
    queryKey: ["userSuggestions", search, page, limit, ordering, status],
    queryFn: () =>
      fetchUserSuggestions({
        search: search || undefined,
        limit,
        offset: (page - 1) * limit,
        ordering,
        status,
      }),
    retry: 0,
  });
};
